module.exports = __webpack_public_path__ + "img/energyFetchExampleUs.e6622743.png";